import type { FC, PropsWithChildren } from "react";
import { Tree } from "react-aria-components";
import { tv } from "tailwind-variants";

//
// Props.
//

interface AssessmentTableProps extends PropsWithChildren {
  className?: string;
  columns?: 1 | 2 | 3;
  defaultExpandedIds?: readonly string[];
}

//
// Style.
//

const tableStyle = tv({
  base: `
    grid
    grid-flow-row
    gap-x-6
    text-sm
  `,
  variants: {
    columns: {
      1: `grid-cols-[minmax(0,1fr)]`,
      2: `grid-cols-[minmax(0,1fr)_auto]`,
      3: `grid-cols-[minmax(0,3fr)_auto_minmax(0,6fr)]`,
    },
  },
});

//
// Component.
//

export const AssessmentTable: FC<AssessmentTableProps> = (props) => {
  const { defaultExpandedIds, columns = 3, children } = props;
  return (
    <Tree
      aria-label="Assessment criteria"
      className={tableStyle({ columns, className: props.className })}
      defaultExpandedKeys={defaultExpandedIds}
    >
      {children}
    </Tree>
  );
};
